module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible && _vm.compyinfo) ? _c('div', {
    staticClass: "modal",
    class: {
      fadeIn: _vm.visible, fadeOut: !_vm.visible
    }
  }, [_c('div', {
    staticClass: "modal-mask-cf"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-con"
  }, [_c('div', {
    staticClass: "modal-con-main"
  }, [_c('span', {
    staticClass: "iconfont icon-guanbi",
    on: {
      "click": _vm.handleClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-header"
  }, [_vm._v("确认下载简历")]), _vm._v(" "), _c('div', {
    staticClass: "m-text-1"
  }, [_vm._v("加入人才库后可显示联系方式，随时查看人才信息")]), _vm._v(" "), _c('div', {
    staticClass: "m-content"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "confirm-text"
  }, [_vm._v("确认下载"), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v("的简历，并加入企业人才库吗？")]), _vm._v(" "), (_vm.compyinfo.isVip || _vm.compyinfo.remainCollNum > 0) ? _c('div', {
    staticClass: "cost-text"
  }, [_vm._v("\n            需要消耗下载权益"), _c('font', {
    staticClass: "blue"
  }, [_vm._v("1")]), _vm._v("次，\n            "), _c('span', {
    staticClass: "s"
  }, [_vm._v("剩余免费下载次数："), _c('font', {
    class: _vm.compyinfo.remainCollNum ? 'blue' : 'red'
  }, [_vm._v(_vm._s(_vm.compyinfo.remainCollNum))]), _vm._v("次")], 1)], 1) : _c('div', {
    staticClass: "cost-text"
  }, [_vm._v("\n            需要消耗"), _c('font', {
    staticClass: "red"
  }, [_vm._v("10.0")]), _vm._v("平台币，"), _c('span', {
    staticClass: "s"
  }, [_vm._v("当前的账户余额："), _c('font', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.compyinfo.availableFunds))]), _vm._v("平台币")], 1)], 1)]), _vm._v(" "), (!_vm.recruitId) ? _c('div', {
    staticClass: "content-box position-select"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("简历关联的岗位\n          "), _c('el-select', {
    attrs: {
      "placeholder": "请选择岗位"
    },
    model: {
      value: (_vm.selectedPosition),
      callback: function($$v) {
        _vm.selectedPosition = $$v
      },
      expression: "selectedPosition"
    }
  }, _vm._l((_vm.positions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.compyinfo.isVip || _vm.compyinfo.remainCollNum > 0) ? [_c('el-button', {
    staticClass: "submit-btn",
    attrs: {
      "disabled": !_vm.compyinfo.remainCollNum,
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("\n            确认下载\n          ")]), _vm._v(" "), (!_vm.compyinfo.remainCollNum) ? _c('div', {
    staticClass: "vip-text",
    on: {
      "click": _vm.gocharge
    }
  }, [_vm._v("去充值")]) : _vm._e()] : [(!_vm.showpwd) ? _c('el-button', {
    staticClass: "submit-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pingchange
    }
  }, [_vm._v("支付10.0平台币")]) : _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "46px",
      "margin-top": "10px"
    }
  }, [_c('ul', {
    staticClass: "mz-pwd"
  }, _vm._l((_vm.pwdlist), function(item, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), ((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pwdIinps) ? _vm._i(_vm.pwdIinps, null) > -1 : (_vm.pwdIinps)
    },
    on: {
      "focus": _vm.focusInput,
      "change": function($event) {
        var $$a = _vm.pwdIinps,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.pwdIinps = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.pwdIinps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.pwdIinps = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "autocomplete": "off",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.pwdIinps, null)
    },
    on: {
      "focus": _vm.focusInput,
      "change": function($event) {
        _vm.pwdIinps = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwdIinps),
      expression: "pwdIinps"
    }],
    staticClass: "mz-btn mz-btn-orange mz-inp-orange",
    attrs: {
      "maxlength": "6",
      "placeholder": "请输入密码",
      "autocomplete": "off",
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.pwdIinps)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwdIinps = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vip-text",
    on: {
      "click": _vm.goVip
    }
  }, [_vm._v("开通会员获得免费次数")])]], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf62668e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewConfirm.vue
// module id = 913
// module chunks = 1